export default __webpack_public_path__ + "static/media/dashboard_active.3b227a52.svg";